function isEmpty(value) {
  return value === "" || value === null || value === undefined;
}

function isValidCoordinate(value) {
  return typeof value === "number" && !Number.isNaN(value);
}

export function validateGlobalCityPayload({ name, latitude, longitude }) {
  if (!name || !name.trim()) {
    return "El nombre personalizado es obligatorio.";
  }

  if (isEmpty(latitude) || !isValidCoordinate(latitude)) {
    return "La latitud de la ciudad es obligatoria.";
  }

  if (isEmpty(longitude) || !isValidCoordinate(longitude)) {
    return "La longitud de la ciudad es obligatoria.";
  }

  return null;
}
